export const notificationBuckets: string[] = ['PATIENT_SMS', 'DM'];